export default __webpack_public_path__ + "static/media/5S.f4e082a6.svg";